import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api, type EventDashboard, type SendInvitesResult } from '../api/client.js';

export function useDashboard(eventId: string) {
  return useQuery<EventDashboard>({
    queryKey: ['dashboard', eventId],
    queryFn: () => api.dashboard.get(eventId),
    enabled: !!eventId,
    refetchInterval: 30_000, // Auto-refresh every 30s for real-time feel
  });
}

export function useSendInvites() {
  const queryClient = useQueryClient();
  return useMutation<SendInvitesResult, Error, string>({
    mutationFn: (eventId: string) => api.email.sendInvites(eventId),
    onSuccess: (_result, eventId) => {
      queryClient.invalidateQueries({ queryKey: ['dashboard', eventId] });
      queryClient.invalidateQueries({ queryKey: ['event', eventId] });
      queryClient.invalidateQueries({ queryKey: ['events'] });
    },
  });
}
